<template>
	<el-dialog
		title="导入快捷短语(个人)"
		:visible.sync="visibleProxy"
		width="960px"
		append-to-body
		custom-class="fri-dialog"
	>
		<div class="fri-desc">添加导入：在现有快捷短语后方增加新导入的短语</div>
		<div class="fri-file-row">
			<div class="fri-label">文件路径：</div>
			<el-input v-model="filePath" placeholder="/Users/xxx/Downloads/快捷短语.csv" class="fri-input" size="small"></el-input>
			<input ref="fileInput" type="file" accept=".csv,.txt,.xls,.xlsx" class="fri-file" @change="onFileChange" />
			<el-button class="fri-choose" size="small" @click="chooseFile">选择文件</el-button>
		</div>
		<el-table :data="tableData" border height="380" class="fri-table">
			<el-table-column prop="index" label="编号" width="70" align="center"/>
			<el-table-column prop="code" label="短语编码" width="120"/>
			<el-table-column prop="content" label="短语内容" min-width="260" show-overflow-tooltip/>
			<el-table-column prop="group" label="分组名" width="120"/>
			<el-table-column prop="image" label="图片(仅支持链接)" min-width="180" show-overflow-tooltip/>
			<el-table-column prop="status" label="状态" width="100" align="center"/>
		</el-table>
	</el-dialog>
</template>

<script>
export default {
	name: 'FastReplyImportDialog',
	props: {
		visible: { type: Boolean, default: false },
		sceneId: { type: String, default: 0 },
	},
	data() {
		return {
			filePath: '',
			fileBlob: null,
			tableData: [],
		};
	},
	computed: {
		visibleProxy: {
			get() { return this.visible; },
			set(v) { this.$emit('update:visible', v); }
		}
	},
	methods: {
		chooseFile() {
			this.$refs.fileInput && this.$refs.fileInput.click();
		},
		loadReplyList() {
			this.$http.post(API_ROOT.newcustomer + '/train/reply/search?type=1&sceneId=' + this.sceneId).then(res => {
				const result = res.data;
				if (result && result.success) {
					const typeList = Array.isArray(result.data && result.data.typeList) ? result.data.typeList : [];
					// 构建父级名称索引
					const idToItem = {};
					typeList.forEach(t => { idToItem[t.id] = t; });
					let index = 1;
					const rows = [];
					typeList.forEach(t => {
						const parentName = t.name;
						const replies = Array.isArray(t.replyList) ? t.replyList : [];
						replies.forEach(r => {
							rows.push({
								index: index++,
								code: r.quicktext || '',
								content: r.replytext || '',
								group: parentName,
								image: '',
								status: '完成'
							});
						});
					});
					this.tableData = rows;
				} else {
					this.$message({
						message: result.msg,
						type: 'error'
					});
				}
			}, err => {
				this.$message({
					message: '保存失败',
					type: 'error'
				});
			});
		},
		onFileChange(e) {
			const file = e && e.target && e.target.files ? e.target.files[0] : null;
			if (!file) return;
			this.fileBlob = file;
			this.filePath = file.name;
			const formdata = new FormData();
			// 文件
			formdata.append('file', file);
			// 附带元字段，形成多 part 提交
			formdata.append('id', 'WU_FILE_0');
			formdata.append('name', file.name || '');
			formdata.append('type', file.type || '');
			formdata.append('lastModifiedDate', (file.lastModified ? new Date(file.lastModified) : new Date()).toLocaleString());
			formdata.append('size', file.size != null ? String(file.size) : '');
			this.$http.post(
				API_ROOT.newcustomer + '/simulationExercise/reply/importReply?importType=override&sceneId=' + this.sceneId,
				formdata,{ headers: { 'Content-Type': 'multipart/form-data' }}
			).then(res => {
				var result = res.data;
				if (result.success) {
					this.$emit('refresh');
					this.loadReplyList();
				} else {
					this.$message({
						message: result.msg,
						type: 'error'
					});
				}
			}, res => {
				this.$message({
					message: '导入失败',
					type: 'error'
				});
			});
		}
	}
};
</script>

<style lang='less' scoped>
.fri-dialog {
	/deep/ .el-dialog__header {
		background-color: #2d6cf6;
		color: #fff;
		padding: 12px 20px;
	}
	/deep/ .el-dialog__title { color: #fff; font-weight: 600; }
	/deep/ .el-dialog__headerbtn .el-dialog__close { color: #fff; }
    /deep/ .el-dialog__body { padding: 10px 20px; }
}

.fri-desc {
	margin: 8px 0 12px 0;
	color: #666;
	font-size: 13px;
}

.fri-file-row {
	display: flex;
	align-items: center;
	margin-bottom: 8px;
}
.fri-label { width: 70px; color: #333; font-size: 13px; }
.fri-input { flex: 1; margin-right: 8px; }
.fri-file { display: none; }
.fri-choose { width: 80px; padding: 10px 10px; }

.fri-table {
	/deep/ .el-table__header th { background: #f7f8fa; color: #333; }
}
</style>





// WEBPACK FOOTER //
// ./src/page/train/FBT/components/FastReplyImportDialog.vue